import { stateStripeOpt } from "../../../utils/state-opt";
import { addToQuery } from "../../utils/query.tsx"
import { dateToStripeTimestamp } from "../../utils/timestamp.tsx";
import { PaymentIntent } from "../paymentIntent.tsx";

export class SearchPaymentIntentResponse {
    private paymentIntents: PaymentIntent[];
    private nextPage: string|null;
    private hasMore: boolean|null;
    private error: string|null;

    constructor(paymentIntents: PaymentIntent[], nextPage: string|null, hasMore: boolean|null, error: string|null) {
        this.setPaymentIntents(paymentIntents);
        this.setNextPage(nextPage);
        this.setHasMore(hasMore);
        this.setError(error);
    }

    private setPaymentIntents(newPaymentIntents:PaymentIntent[]) {
        this.paymentIntents = newPaymentIntents;
    }
    private setNextPage(newNextPage:string|null) {
        this.nextPage = newNextPage;
    }
    private setHasMore(newHasMore:boolean|null) {
        this.hasMore = newHasMore;
    }
    private setError(newError:string|null) {
        this.error = newError;
    }

    getPaymentIntents() {
        return this.paymentIntents;
    }
    getNextPage() {
        return this.nextPage;
    }
    getHasMore() {
        return this.hasMore;
    }
    getError() {
        return this.error;
    }
}

export async function searchPaymentIntent(minAmount:number|null|undefined, maxAmount:number|null|undefined, minDate:Date|null|undefined, maxDate:Date|null|undefined, state:number|null|undefined, nextPage:string|null):Promise<SearchPaymentIntentResponse> {
    try {
        var query:string = '';

        console.log(minAmount, maxAmount, minDate, maxDate, state);

        
        if (minAmount !== null && minAmount !== undefined) {
            query = addToQuery(query, `amount>=${Math.trunc(minAmount*100)}`);
        }
        if (maxAmount !== null && maxAmount !== undefined) {
            query = addToQuery(query, `amount<=${Math.trunc(maxAmount*100)}`);
        }
        if (minDate !== null && minDate !== undefined) {
            query = addToQuery(query, `created>=${dateToStripeTimestamp(minDate)}`);
        }
        if (maxDate !== null && maxDate !== undefined) {
            query = addToQuery(query, `created<=${dateToStripeTimestamp(maxDate)}`);
        }
        if (state !== null && state !== undefined) {
            query = addToQuery(query, `status:'${stateStripeOpt[state]}'`);
        }

        if (query.length === 0) {
            query = 'amount>=0';
        }

        console.log(query);

        const retVal:PaymentIntent[] = [];

        const stripe = require('stripe')(`${process.env.REACT_APP_STRIPE}`);
        var balance:any;

        if (nextPage !== null) {
            balance = await stripe.paymentIntents.search({
                query: query,
                limit: 20,
                page: nextPage,
            });
        } else {
            balance = await stripe.paymentIntents.search({
                query: query,
                limit: 20,
            });
        }

        console.log(balance);
        for (const paymentIntent of balance.data) {
            retVal.push(PaymentIntent.fromJson(paymentIntent));
        }

        console.log(retVal);

        return new SearchPaymentIntentResponse(retVal, balance.next_page, balance.has_more, null);
    } catch (e) {
        return new SearchPaymentIntentResponse([], null, null, e.message);
    }
}